package com.example.positionahead.model

import kotlinx.serialization.Serializable

@Serializable
data class Quote(
    val symbol: String,
    val price: Double,
    val changePercent: Double = 0.0,
    val dividendYield: Double = 0.0,
    val name: String = "",
    val yearHigh: Double? = null,
    val yearLow: Double? = null,
    val peRatio: Double? = null,
    /** True when price came from the market data API (not demo/estimated fallback). */
    val isLivePrice: Boolean = true,
)
